export function getAvatarUrl(charname: string): string {
    return "https://static.f-list.net/images/avatar/" + charname.toLowerCase() + ".png"
}

export function getProfileUrl(charname: string): string{
    return "https://www.f-list.net/c/" + charname
}